// extracted by mini-css-extract-plugin
export default {"root":"button-delete_root__GxaJs"};